import { render, staticRenderFns } from "./MachineDetails.vue?vue&type=template&id=79af7f4d"
import script from "./MachineDetails.vue?vue&type=script&lang=js"
export * from "./MachineDetails.vue?vue&type=script&lang=js"
import style0 from "./MachineDetails.vue?vue&type=style&index=0&id=79af7f4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports